import { useNavigate } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { PrivateTemplateInfoModal } from '../../../../../template-info-modal';
import { useAppDispatch, useAppSelector } from '../../../../../../../../../shared/libs/redux';
import { useDownloadPDF } from '../../../../../template-info-modal/hooks/useDownloadPDF';
import { useUnbindPrivateTemplateTag } from '../../../api/useUnbindPrivateTemplateTag';
import { personalAccountSlice } from '../../../../../../../../../entities/user/account/personalAccountReducer';
import { templatePrivateAPI } from '../../../../../../../../../entities/template/private-template/api/api';
import { useEditPrivateTemplateName } from '../../../../../../../../../features/template/edit-name';
import {
	privateTemplateSlice,
} from '../../../../../../../../../entities/template/private-template/model/privateTemplateSlice';
import { templateTagSlice } from '../../../../../../../../../entities/template/private-template-tag';
import IBaseEditor from '@start-set/wakadoo-editor-core/impl/IBaseEditor';
import { IGetOfferResponse } from '../../../../../../../../../entities/offer/api/types';
import { ContentConverterEditor, PrivateTemplateEditor } from '@start-set/wakadoo-editor-core';
import { notificationError } from '../../../../../../../../Notifications/callNotifcation';
import { IPrivateTemplateData } from '../../../../../../../../../entities/template/types';

export const PrivateTemplateInfoModalWrapper = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const isBasicTariff = useAppSelector(personalAccountSlice.selectors.isBasicTariff);

	const id = useAppSelector(state => state.privateTemplate.selectedTemplateId);
	const { data, error } = templatePrivateAPI.useGetQuery({ id: id || '' }, { skip: !id });

	const onDownloadPDF = async (editor: PrivateTemplateEditor | null, template: IPrivateTemplateData) => {
		const structure = editor?.getStructure();

		if (structure) {
			const contentConvertEditor = new ContentConverterEditor({
				isEnableMouseWheel: false,
				isCanvasHeightAdaptive: true,
				imageFileSourcePrefix: '/api/file/user'
			});
			await contentConvertEditor.setStructure({
				...template,
				root: structure.root,
			})
			await contentConvertEditor.savePdf(template.name);
		} else {
			notificationError('Ошибка', 'Не удалось найти структуру для скачивания PDF');
		}
	};

	const { editName } = useEditPrivateTemplateName(id || '');
	const { unbindTag } = useUnbindPrivateTemplateTag(id || '');

	const isActive = useAppSelector(privateTemplateSlice.selectors.getIsTemplateInfoModalActive);
	const isDeleteModalActive = useSelector(templateTagSlice.selectors.getIsDeleteTagModalActive);
	const isEditModalActive = useSelector(templateTagSlice.selectors.getIsEditTagModalActive);

	const setModalVisibility = (value: boolean) => {
		dispatch(privateTemplateSlice.actions.setIsTemplateInfoModalActive(value));
	};

	const onClose = () => {
		setModalVisibility(false);
		dispatch(privateTemplateSlice.actions.setSelectedTemplateId(null));
	};

	useLayoutEffect(() => {
		if (error && 'originalStatus' in error && error.originalStatus === 403) {
			navigate('/collection/forbidden');
		}
	}, [error]);

	if (!data) return null;

	return (
		<PrivateTemplateInfoModal
			isActive={isActive}
			onClose={onClose}
			editName={editName}
			unbindTag={unbindTag}
			data={data}
			onDownloadPDF={onDownloadPDF}
			isPDFAvailable={isBasicTariff}
			isDeleteModalActive={isDeleteModalActive}
			isEditModalActive={isEditModalActive}
		/>
	);
};
